module.exports = __webpack_public_path__ + "img/mundo_green.3c9e901f.png";